<template>
  <div class="talent-index">
    <website-header :setNum="5"></website-header>
    <div class="index-top" :style="`background-image:url('${imgURI + '/static/talent/bjt.png'}');`">
      <!--      <div class="index-top-bor">-->
      <!--        <div class="display-flex tips-c">侃侃 让世界更懂你！</div>-->
      <!--        <div class="display-flex flex-column tips">-->
      <!--          <div class="bold">MAKE THE WORLD</div>-->
      <!--          <div class="font-weight-100">UNDERSTAND YOU BETTER</div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <div id="culture">
      <div class="website-index-tips text-center">
        <span class="tips-about bold">CORPORATE CULTURE</span>
      </div>
      <div class="website-index-tips-c text-center">企业文化<span class="tips-block"></span></div>
    </div>
    <div class="culture-bor">
      <ul class="culture-ul display-flex flex-wrap def-width margin-center justify-content-center">
        <li v-for="(item, index) in cultureList" :key="index">
          <div class="title display-flex align-items-center">
            <img :src="`${imgURI}/static/talent/${item.icon}`"/>
            <div class="font-18 bold">{{item.title}}</div>
          </div>
          <div class="content color-979797 font-12">{{item.content}}</div>
        </li>
      </ul>
    </div>
    <div class="photo display-flex justify-content-between def-width margin-center">
      <div>
        <img :src="`${imgURI}/static/talent/tu1.png`"/>
      </div>
      <div>
        <div>
          <img :src="`${imgURI}/static/talent/tu2.png`"/>
          <img :src="`${imgURI}/static/talent/tu3.png`"/>
        </div>
        <div>
          <img :src="`${imgURI}/static/talent/tu4.png`"/>
        </div>
      </div>
    </div>
    <div class="photo-other">
      <img :src="`${imgURI}/static/talent/tu5.png`"/>
    </div>
    <div id="join" class="bottom-content display-flex justify-content-center align-items-center">
      <img :src="`${imgURI}/static/talent/ewm.png`"/>
      <div>
        <div class="title font-24 bold color-292C2E">办公地点</div>
        <div class="address color-292C2E font-16">
          重庆总部：重庆市江北区江北嘴金融城3号T3<br/>
          深圳分公司：深圳市龙华区 民治街道优城商务大厦B座<br/>
          <div class="email font-12">
            简历可投递至邮箱：tangshuang01@inkankan.cn
          </div>
        </div>
      </div>
    </div>
    <website-bot></website-bot>
  </div>
</template>

<script>
import WebsiteBot from '@/components/public/websiteBot'
import WebsiteHeader from '@/components/public/header'
import config from '@/config/index'
export default {
  name: 'talentIndex',
  components: {WebsiteBot, WebsiteHeader},
  data () {
    return {
      imgURI: config.imgURI,
      cultureList: [
        {
          title: '创业心态',
          content: '秉持职业化的态度和素养，始终保持主人翁意识，不推诿不退缩，以强大的内驱力去拼搏前进',
          icon: 'tb1.png'
        },
        {
          title: '破界思维',
          content: '跳出固有认知，脱离本位主义，乐于分享，从全新或不同的角度去思考，跨领域交流、融会贯通，创造无限可能',
          icon: 'tb2.png'
        },
        {
          title: '力求甚解',
          content: '着眼于问题出现的根本，而非解决不断出现的问题，不断优化探索，力求知行合一',
          icon: 'tb3.png'
        },
        {
          title: '内视反听',
          content: '既能反省自己的言行，也能听取别人的意见，做更好的自己',
          icon: 'tb4.png'
        },
        {
          title: '合作共赢',
          content: '没有完美的个人，只有完美的团队。首先真诚面对自己，然后真诚对待他人，推动团队的成长，引领团队的发展',
          icon: 'tb5.png'
        },
        {
          title: '自我提升',
          content: '打造终身成长的思维模式，持续学习，保有进取之心',
          icon: 'tb6.png'
        }
      ]
    }
  },
  watch: {
    // 监听路由对象$route的变化
    '$route': {
      handler: function (to, from) {
        if (to) {
          this.goAnchor(to.query.id)
        }
      },
      deep: true
    }
  },
  mounted () {
    if (this.$route.query.id) {
      this.goAnchor(this.$route.query.id)
    }
    // this.setCrossBorder()
  },
  methods: {
    goAnchor (id) {
      document.querySelector(`#${id}`).scrollIntoView({
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.talent-index{
    .index-top{
      margin-top: -100px;
      width: 100%;
      height: 750px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      .index-top-bor{
        padding-top: 180px;
        margin: 0 auto;
        width: 1200px;
      }
      .tips{
        font-size: 25px;
        color: #ffffff;
      }
      .tips-c{
        letter-spacing: 8px;
        font-size: 48px;
        font-weight: bold;
        color: #ffffff;
      }
    }
  .website-index-tips{
    padding: 146px 0 0 0;
  }
  .website-index-tips-c{
    padding-bottom: 60px;
    font-size: 24px;
  }
  .tips-about{
    letter-spacing: 2px;
    font-size: 25px;
  }
  .tips-block{
    position: relative;
    top: 2px;
    margin-left: 6px;
    display: inline-block;
    width: 12px;
    height: 12px;
    background: #0685D9;
    border-radius: 2px 2px 2px 2px;
  }
  .culture-bor{
    background: #FBFCFE;
    width: 100%;
    .culture-ul{
      padding: 80px 0;
      gap: 40px;
      li{
        padding: 40px 20px;
        width: 240px;
        background: #FFFFFF;

        box-shadow: 0 0 10px #eaeaea;
        .title{
          color: #0685D9;
          gap: 6px
        }
        img{
          //width: 28px;
          height: 26.27px;
        }
        .content{
          margin-top: 10px;
          height: 80px;
        }
      }
    }
  }
  .photo{
    margin: 110px auto 30px auto;
  }
  .photo-other{
    margin-bottom: 229px;
    width: 100%;
    img{
      width: 100%;
    }
  }
  .bottom-content{
    margin-bottom: 206px;
    gap: 22px;
    .address{
      line-height: 30px;
    }
    .email{
      color: #919191;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/talent/index.vue